// extracted by mini-css-extract-plugin
export default {"CreateRoundConfigContent":"CreateRoundConfigContent_CreateRoundConfigContent__3+mqm"};